import { render } from "./SelectPriceTypeComponent.vue?vue&type=template&id=6159beef&scoped=true&ts=true"
import script from "./SelectPriceTypeComponent.vue?vue&type=script&lang=ts"
export * from "./SelectPriceTypeComponent.vue?vue&type=script&lang=ts"

import "./SelectPriceTypeComponent.vue?vue&type=style&index=0&id=6159beef&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6159beef"]])

export default __exports__